import type {
  AnswerHtmlNode,
  AnswerHtmlParse,
} from '@seen/core/models/care-plans/answerScaffold'

/* The browser's half of the shared answer line model (`@seen/core`'s
 * `answerScaffold`). The server supplies the same shape from
 * `node-html-parser`, so the rules downstream of this parse — what a line is,
 * what a heading is, when a label matches — are asked of one implementation
 * rather than two that can drift apart. */
export const parseAnswerHtml: AnswerHtmlParse = (html) => {
  const body = new DOMParser().parseFromString(html, 'text/html').body
  const nodes: AnswerHtmlNode[] = []
  for (const node of Array.from(body.childNodes)) {
    if (node.nodeType === Node.TEXT_NODE) {
      nodes.push({ kind: 'text', text: node.textContent ?? '' })
      continue
    }
    if (!(node instanceof Element)) {
      continue
    }
    nodes.push({
      kind: 'element',
      tagName: node.tagName,
      innerHtml: node.innerHTML,
      outerHtml: node.outerHTML,
      text: node.textContent ?? '',
    })
  }
  return nodes
}
